import styled from '@emotion/styled';
import {ReactComponent as NotFoundSVG} from '../../assets/icons/ic_404.svg';
import {ReactComponent as BackArrowSVG} from '../../assets/icons/ic_arrow_left.svg';

export const PageWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.xxl};
`;

export const PageBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

export const TextsWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: ${({theme}) => theme.gap.desktop.xs};
`;

export const Icon404 = styled(NotFoundSVG)`
  width: 193px;
  height: 72px;
`;

export const IconBack = styled(BackArrowSVG)`
  width: ${({theme}) => theme.icon.size.md};
  height: ${({theme}) => theme.icon.size.md};
  fill: ${({theme}) => theme.color.primary};
`;
